import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowUpRightFromSquare,
  faXmark,
} from '@fortawesome/sharp-solid-svg-icons';
import Link from 'next/link';
import React, { useMemo } from 'react';
import { twMerge } from 'tailwind-merge';

import { ButtonSize, ButtonVariant } from '@/components/button';
import IconButton from '@/components/button/iconButton';
import Typography from '@/components/typography';
import { GLOBAL_TOOLTIP } from '@/constants/constants';
import { useAuth } from '@/providers/auth-provider';
import { useFileManagementContext } from '@/providers/FileManagementProvider';

import { useNavigationContext } from '../provider';
import FileOverflow from './fileOverflow';

const FileTab = () => {
  const { activeFile, closeActiveFile } = useFileManagementContext();

  const { userCanSalesforce } = useAuth();

  const { aerialMapIsOpen } = useNavigationContext();

  const showSalesforceLink = useMemo(() => {
    if (!userCanSalesforce) return false;

    return !!activeFile?.salesforce_object;
  }, [activeFile, userCanSalesforce]);

  const handleClose = () => {
    closeActiveFile?.();
  };

  return activeFile ? (
    <div className="group flex h-full items-center px-0 hover:bg-gray-10">
      <div className="flex w-fit gap-2 pl-3 pr-1">
        {showSalesforceLink && activeFile.salesforce_object && (
          <div className="flex flex-row gap-2">
            <Link
              className="flex gap-1 text-blue-utility"
              href={activeFile.salesforce_object.full_url}
              target="_blank"
            >
              <Typography variant="button2">
                {activeFile.salesforce_object.name}
              </Typography>
              <FontAwesomeIcon
                className="h-4 w-4"
                icon={faArrowUpRightFromSquare}
              />
            </Link>

            <Typography className="text-gray-50" variant="button2">
              |
            </Typography>
          </div>
        )}

        <Typography
          className="max-w-[168px] overflow-hidden text-ellipsis whitespace-nowrap sm:max-w-[240px]"
          variant="body2"
        >
          {activeFile.name}
        </Typography>
      </div>

      <div className="flex h-full items-center hover:bg-gray-20">
        <FileOverflow className="hover:bg-transparent" file={activeFile} />
      </div>
      <div
        className="flex h-full w-[32px] items-center px-1 hover:bg-gray-20"
        data-tooltip-content={!aerialMapIsOpen ? 'Close Map' : ''}
        data-tooltip-id={GLOBAL_TOOLTIP}
      >
        <IconButton
          className={twMerge(
            'hidden px-3 text-gray-100 hover:bg-gray-40 hover:bg-transparent group-hover:flex',
            aerialMapIsOpen && 'text-gray-50'
          )}
          disabled={aerialMapIsOpen}
          size={ButtonSize.XS}
          variant={ButtonVariant.GHOST}
          onClick={handleClose}
        >
          <FontAwesomeIcon icon={faXmark} size="lg" />
        </IconButton>
      </div>
    </div>
  ) : null;
};

export default FileTab;
